import { EXCLUDED_FQDN_RU } from '@/constants/excludedNodeFromTree';
import { fetchRegion } from '@/api';

type GateResult = {
  allow: boolean;
  statusCode?: number;
};

const ALLOW_RESULT: GateResult = { allow: true };
const DENY_RESULT: GateResult = { allow: false, statusCode: 404 };

export const getIsUrlAllowed = async (url: string): Promise<GateResult> => {
  if (!url.includes(EXCLUDED_FQDN_RU)) {
    return ALLOW_RESULT;
  }

  try {
    const response = await fetchRegion();
    const countryCode = response.data.country_code?.toLowerCase();

    if (!countryCode || countryCode === 'ru') {
      return DENY_RESULT;
    }

    return ALLOW_RESULT;
  } catch (error) {
    console.error('Failed to fetch region data:', error);
    return ALLOW_RESULT;
  }
};
